import React from 'react';
import { Modal, Button, Alert as BSALert } from 'react-bootstrap';
import { Field, Form, Formik } from 'formik';
import useAxios from "axios-hooks";
import { FormattedMessage } from 'react-intl'

import { Input, ReactSelect, RichText } from '../../../formik';

const EmailParticipantsModal = ({
  show,
  onHide,
  intl,
  selectedParticipants, 
  event_slug //Diljith krishna - 2026-01-29 - Added to send event slug to backend
}) => {
  const [{ loading }, sendEmail] = useAxios({
    url: `${process.env.REACT_APP_API_HOST}/event-engagement/email`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    method: "POST",
  },
    {
      manual: true,
    });


  return (
    <Modal className="list-modal-form" show={show} onHide={onHide} >
      <Modal.Header closeButton>
        <h4>{intl.formatMessage({ id: 'email.participants' })}</h4>
      </Modal.Header>
      <Modal.Body>
        <Formik //Diljith krishna - 2026-01-29 - updated message by including [ENGAGEMENT_URL]
          initialValues={{
            to: selectedParticipants.map(({ id }) => id),
            subject: '',
            message: ` 
<p>Hello Participant,</p>

<p>You have been invited to attend a live presentation.</p>

<p><b>Login details:</b></p>
<p>Email: [EMAIL]<br/>
Password: [PASSWORD]</p>

<p>
To join the live session, please use the link below and log in with the credentials provided.
Once logged in, you can access the presentation and join the live stream.
</p>

<p>
<a href="[ENGAGEMENT_URL]" target="_blank">
Join the Live Presentation
</a>
</p>

<p>Thank you.</p>
`
            ,
          }}
          onSubmit={async (values) => {
            try {
              await sendEmail({
                data: {
                  ...values,
                  eventSlug: event_slug,
                  audienceSiteRoot: process.env.REACT_APP_AUDIENCE_SITE_ROOT, // Diljith krishna - 2026-01-29 - Added to send URL to backend
                  to: selectedParticipants
                    .filter(p => values.to.includes(p.id))
                    .map(({ id, source, cant_delete, ...rest }) => rest)
                }
              })
              // TODO
              alert('Email sent successfully.')
              onHide();
            } catch (e) {
              // Log full error for debugging (staging vs production)
              const errMsg = e.response?.data?.message
                || e.response?.data?.error
                || (typeof e.response?.data === 'string' ? e.response.data : null)
                || e.message;
              console.error('Email send failed:', {
                message: errMsg,
                status: e.response?.status,
                url: e.config?.url,
                fullError: e
              });
              const userMessage = errMsg
                ? `Error: ${errMsg}${e.response?.status ? ` (${e.response.status})` : ''}`
                : 'There was an error while sending the email. Check the browser console for details.';
              alert(userMessage);
            }
            // Alert.success(intl.formatMessage({id: 'email.success'}))
            // Alert.error(intl.formatMessage({id: 'email.error'}))
          }
          }>
          {({ values }) => {
            return (
              <Form>
                <Field
                  name="to"
                  id="to"
                  placeholder={intl.formatMessage({ id: 'input.to' })}
                  component={ReactSelect}
                  isMulti
                  options={selectedParticipants.map(p => ({ label: p.email, value: p.id }))}
                // isDisabled={true}
                />
                <Field
                  name="subject"
                  type="text"
                  id="subject"
                  placeholder={intl.formatMessage({ id: 'input.subject' })}
                  component={Input}
                  required
                />
                <Field
                  component={RichText}
                  name="message"
                // label={intl.formatMessage({
                //   id: "input.emailContent",
                // })}
                />
                <Button type="submit" disabled={loading}>{intl.formatMessage({ id: 'button.submit' })}</Button>
              </Form>
            )
          }}
        </Formik>
        <BSALert className="custom-alert-mail" variant="info">
          <BSALert.Heading>
            <FormattedMessage id="heading.substitutions" />
          </BSALert.Heading> 
          <b>[EMAIL]</b> - Email
          <br />
          <b>[PASSWORD]</b> - Password
          <br />
          <b>[ENGAGEMENT_URL]</b> - Engagement login link
        </BSALert>

      </Modal.Body>
    </Modal>
  )
}

export default EmailParticipantsModal;